export default __webpack_public_path__ + "static/media/Background_DRagonScales.8c3115c2.svg";